<template>
  <div
    ref="scrollContainer"
    class="border border-[#E5E7EB] rounded-[8px] max-h-[500px] overflow-y-auto"
  >
    <BTable
      :items="fetcher.data || []"
      :fields="config.fields"
      borderless
      responsive
      :show-empty="!loading"
      sticky-header
      empty-text="Tidak ada data yang tersedia"
      class="mb-0"
    >
      <template #cell(nama_kategori)="data">
        <div class="text-[14px] text-[#222222]">
          {{ data.value }}
        </div>
      </template>
      <template #cell(article_count)="data">
        <div class="text-[14px] text-[#222222]">
          {{ data.value }} Artikel
        </div>
      </template>
      <template #cell(action)="data">
        <div v-if="data.item.name !== 'Tanpa Kategori'" class="d-flex align-items-center gap-[8px]">
          <b-button
            class="bg-white !flex items-center justify-center !p-0 !rounded-[8px] border border-[#E5E7EB] !h-[32px]"
            size="sm"
            variant="light"
            @click="openEdit(data.item)"
          >
            <div class="d-flex align-items-center text-[#0A0A0A] gap-[4px] px-[8px] py-[4px] !shadow-xs">
              <span class="k-edit" />
              <span class="text-[14px] !font-medium">Edit</span>
            </div>
          </b-button>
          <b-button
            class="!bg-[#FEF2F2] !rounded-[8px] border-0 !size-[32px] !p-0"
            size="sm"
            variant="light"
            :disabled="data.item.name === config.DEFAULT_CATEGORY_NAME"
            @click="openDelete(data.item)"
          >
            <div class="d-flex align-items-center gap-[4px] px-[8px] py-[4px]">
              <span class="k-trash text-[#DC2626] text-[16px]" />
            </div>
          </b-button>
        </div>
      </template>
      <template #custom-foot>
        <tr>
          <td
            colspan="3"
            class="p-0 border-0"
          >
            <div
              v-if="loading"
              class="p-[16px] text-center text-sm text-gray-500"
            >
              Loading...
            </div>
          </td>
        </tr>
      </template>
    </BTable>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { CATEGORY_TABLE_FIELDS, DEFAULT_CATEGORY_NAME } from './config'

export default {
  name: 'CategoryTable',
  data() {
    return {
      fetcher: null,
    }
  },
  computed: {
    loading() {
      return this.fetcher?.isLoading || false
    },
    /**
     * Provides table configurations including column definitions and defaults.
     */
    config() {
      return {
        DEFAULT_CATEGORY_NAME,
        fields: CATEGORY_TABLE_FIELDS,
      }
    },
  },
  created() {
    // TODO: for now, we doesn't use infinite fetch for category, but we keep this method for future use
    this.fetcher = createPaginatedFetcher(async () => {
      const { data } = await this.$http_new.get('/live-chat/api/v1/categories')
      this.$emit('count-update', data.data.total)
      this.$emit('data-ready', data.data.categories)
      return { data: data.data.categories }
    })
    this.fetcher.fetchData({ reset: true })
  },
  methods: {
    openEdit(item) {
      this.$emit('edit', item)
    },
    openDelete(item) {
      this.$emit('delete', item)
    },
    refresh() {
      if (this.fetcher) {
        this.fetcher.fetchData({ reset: true })
      }
    },
    loadMoreData() {
      if (this.loading) return

      this.$emit('load-more')

      if (this.fetcher && this.fetcher.hasMore) {
        this.fetcher.fetchData()
      }
    },
  },
}
</script>

<style scoped>
::v-deep .table {
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0 !important;
}
::v-deep thead th {
  border: none !important;
}
::v-deep tbody td {
  border: none !important;
}
</style>
